import { FC } from 'react';

export const ErrorPage: FC = () => {
  return <div>От халепа, щось ви не те в адресу вписали</div>;
};
